import Button from '@amzn/meridian/button';
import Loader from '@amzn/meridian/loader';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { useGetBusinessCategoriesQuery } from '@amzn/rangoli-seller-desktop-api-utils/src/index';
import { useLogoutUserMutation } from '@amzn/rangoli-seller-desktop-fe-auth-utils/src/index';
import { PathName } from '@amzn/rangoli-seller-desktop-utils/src/index';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import googlePlayIcon from '../../assets/googlePlayIcon.svg';
import securityIcon from '../../assets/help.svg';
import smartBizLogo from '../../assets/logo.svg';
import ProfileMenu from '../../components/ProfileMenu/ProfileMenu';
import QRScanner from '../../components/QRScanner/QRScanner';
import {
  HeaderConstantsData,
  HeaderType,
  ImageAlternatives,
} from '../../constants/mainHeaderConstant';
import { helpAndSupportStore } from '../../store/HelpAndSupportStore';
import { sidebarStore } from '../../store/SidebarStore';
import { userAuthStore } from '../../store/UserAuthStore';
import { borderLeftAndRightStyle, borderRightStyle, headerShadow } from '../../Style/Style';
import { IMainHeaderProps } from '../../types/MainHeaderTypes';

const { PRIMARY_HEADER, SECONDARY_HEADER } = HeaderType;
const { SMARTBIZ, GOOGLE_PLAY, SECURITY } = ImageAlternatives;
const { DO_MORE_WITH_SMARTBIZ, LOGOUT } = HeaderConstantsData;
const HOME = PathName['HOME'];

const MainHeader = ({ mode, storeDetailsLoader }: IMainHeaderProps) => {
  const navigate = useNavigate();
  const { handleScannerToggle, setShowSideBar } = sidebarStore;
  const logoutUserMutation = useLogoutUserMutation();
  const { isLoading } = logoutUserMutation;
  const { setHelpMenuToggle } = helpAndSupportStore;

  const handleLogoutUser = async (): Promise<void> => {
    const res = await logoutUserMutation.mutateAsync();
    userAuthStore.isLoggedOut();
    window.location.replace(res?.redirectUrl);
  };

  const {
    data: CategoriesList,
    isLoading: isCategoryLoading,
    error: categoriesError,
  } = useGetBusinessCategoriesQuery();
  const isCategoryError: boolean = categoriesError ? true : false;

  const handleNavigateToHome = (): void => {
    navigate(HOME);
    setShowSideBar(true);
  };

  return (
    <>
      <Row
        height="56px"
        alignmentHorizontal="justify"
        spacingInset={mode === SECONDARY_HEADER ? 'none 400 none 500' : 'none 500'}
        className={headerShadow}
      >
        <Row alignmentVertical="center" height="100%">
          <Row
            width={mode === PRIMARY_HEADER ? 'calc(240px - 31px)' : '105px'}
            alignmentVertical="center"
            className={borderRightStyle}
            height="100%"
          >
            <Button onClick={handleNavigateToHome} type="icon">
              <img src={smartBizLogo} alt={SMARTBIZ} />
            </Button>
          </Row>
          {mode === SECONDARY_HEADER && (
            <Row alignmentHorizontal="center" alignmentVertical="center" spacingInset="none 300">
              <Text type="b200">{DO_MORE_WITH_SMARTBIZ}</Text>
              <Button onClick={handleScannerToggle}>
                <img src={googlePlayIcon} alt={GOOGLE_PLAY} width="106px" />
              </Button>
            </Row>
          )}
        </Row>
        {mode === SECONDARY_HEADER ? (
          <Button size="small" onClick={handleLogoutUser} minWidth="64px">
            {isLoading ? <Loader size="small" /> : LOGOUT}
          </Button>
        ) : (
          <Row alignmentVertical="center" height="100%">
            <Row
              alignmentVertical="center"
              spacingInset="none 450"
              height="100%"
              className={borderLeftAndRightStyle}
            >
              <Button onClick={setHelpMenuToggle} type="icon">
                <img src={securityIcon} alt={SECURITY} />
              </Button>
            </Row>
            <ProfileMenu
              isLoading={storeDetailsLoader || isCategoryLoading}
              CategoriesList={CategoriesList?.categories}
              isCategoryError={isCategoryError}
              isMenuEnable={true}
            />
          </Row>
        )}
      </Row>
      <QRScanner />
    </>
  );
};

export default observer(MainHeader);
